import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chili"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17 18.5004C12.1261 23.3743 4 20.5004 4 20.5004C4 20.5004 11.4197 18.7253 12.1119 8.17094L13.9958 7.69995L14.9958 9.19995L16.4958 8.19995L17.4958 9.69995L18.9958 8.69995L20.8233 10.5004C20.4571 12.5004 19.2822 16.2181 17 18.5004Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M17.2991 4.30775C14.8475 3.90006 12.2918 5.51439 12.1219 8.00861C12.1187 8.06298 12.1154 8.11715 12.1118 8.1711L13.9958 7.70011L14.9958 9.20011L16.4958 8.20011L17.4958 9.70011L18.9958 8.70011L20.8232 10.5005C20.8842 10.1672 20.9428 9.82864 21 9.48497C21.3638 7.29715 20.0834 5.21581 18.0613 4.50349C17.8175 4.4176 17.5629 4.35161 17.2991 4.30775Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M18.0614 4.50335L18.4959 2.69995M18.0614 4.50335C17.8176 4.41746 17.563 4.35147 17.2992 4.3076C14.8476 3.89992 12.2919 5.51425 12.122 8.00847C12.1188 8.06284 12.1154 8.117 12.1119 8.17096C11.4197 18.7253 4 20.5004 4 20.5004C4 20.5004 12.1261 23.3743 17 18.5004C19.2823 16.2181 20.4571 12.5004 20.8233 10.5004C20.8843 10.167 20.9429 9.8285 21 9.48482C21.3639 7.29701 20.0835 5.21567 18.0614 4.50335ZM12.6 8.04891L13.9958 7.69995L14.9958 9.19995L16.4958 8.19995L17.4958 9.69995L18.9958 8.69995L20.3 9.98484","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Chili = Vue.extend<IconProps>({
  name: 'ChiliIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chili',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Chili;
